import React, { useContext, useState, useEffect } from 'react';
import { MEMBER } from "actions";
import { useTranslation } from "react-i18next";
import {
    Modal,
    MultiSelect,
    AssigneeList,
    ItemCard
} from 'components';
import { GET_FILE } from 'actions/constants';
import { AuthContext, CollaboratorsContext, DocumentsContext, HomeContext } from 'contexts';
import avatar from 'assets/images/avatar.png';
import differenceBy from 'lodash/differenceBy';
const MEMBER_U = MEMBER.toUpperCase();

export const AssignMemberToDocumentV2 = ({ open, onCancel }) => {
    const { t } = useTranslation();
    const { 
        doUpdatePartners, 
        doGetDocumentSignatureDetailVersion,
    } = useContext(DocumentsContext);
    const { 
        memberSelectedForDocument,
        documentId,
        idDocumentSignature,
        setRefreshDocumentSignature,
        refreshDocumentSignature,
        createdByDoc
    } = useContext(HomeContext);
    const { userInfo } = useContext(AuthContext);
    const [memberSelected, setMemberSelected] = useState([]);
    const [arrayMembers, setArrayMembers] = useState([]);
    const [choseMembers, setChoseMembers] = useState([]);
    const { collaborators } = useContext(CollaboratorsContext);
    const inviteByEmail = 'Invite by email';

    /*eslint-disable */
    useEffect(() => {
        setMemberSelected(memberSelectedForDocument.map(item => {
            return {
                email: item.email,
                id: item.id || new Date().getTime().toString(),
                icon: item.id ? (item.type === MEMBER_U ? (item.avatar ? item.avatar : '') : 'icon-users') : 'icon-envelop',
                title: item.id ? item?.name : item.email,
                description: item.id ? (item.type === MEMBER_U ? item.email : item?.name) : inviteByEmail,
                type: item.type,
                name: item.id ? item?.name : item.email
            }
        }));
    }, [memberSelectedForDocument, open]);

    useEffect(() => {
        if(idDocumentSignature && open) doGetDocumentSignatureDetailVersion(idDocumentSignature);
    }, [idDocumentSignature])

    useEffect(() => {
        setArrayMembers(differenceBy(collaborators.filter(x => x._id !== userInfo._id).map(item => {
            item.id = item._id;
            return item;
        }), choseMembers.concat(memberSelected), 'id'));
    }, [collaborators, choseMembers, userInfo, memberSelected]);

    /*eslint-enable */
    const handleAddPartners = () => {
        const partners = memberSelected.concat(choseMembers).map(item => {
            return {
                id: item.id,
                type: item.type
            }
        })
        doUpdatePartners(documentId, { partners }, (data) => {
            if (data) {
                onCancel();
                setMemberSelected([]);
                setChoseMembers([]);
                setRefreshDocumentSignature(!refreshDocumentSignature);
            };
        });
    }

    const handleSearchCollaborators = (index, value) => {
        setArrayMembers(differenceBy(collaborators.filter(x => x._id !== userInfo._id).map(item => {
            item.id = item._id;
            return item
        }), choseMembers.concat(memberSelected), 'id').filter(x => x.name.toLowerCase().includes(value)));
    }

    const handleRemovePartner = (value) => {
        setMemberSelected(oldValue => [...oldValue.filter(val => val.id !== value.id)]);
    }

    const handleOnCancel = () => {
        setChoseMembers([]);
        setMemberSelected([]);
        onCancel();
    }

    return (
        <Modal
            open={open}
            className="tr__assign-modal no-padding"
            onCancel={handleOnCancel}
            title={'Assign To Document'}
            submitButton
            submitButtonLabel={'Save'}
            isBackDropClickable={false}
            onSubmitClick={handleAddPartners}
        >
            <div className="tr__assign-modal--form">
                <MultiSelect
                    className="mbx2"
                    mode="input"
                    options={arrayMembers.map(item => {
                        return {
                            email: item.email,
                            id: item._id || new Date().getTime().toString(),
                            icon: item._id ? (item.type === MEMBER_U ? (item.avatar ? GET_FILE + item.avatar : avatar) : 'icon-users') : 'icon-envelop',
                            title: item._id ? item?.name : item.email,
                            description: item._id ? (item.type === MEMBER_U ? item.email : item?.name) : inviteByEmail,
                            type: item.type
                        }
                    })}
                    value={choseMembers}
                    label={`${t("home.assign.title")} Document`}
                    placeholder={t('home.BookingRequest.addBrCollaborators.placeholder')}
                    onChange={items => {
                        setChoseMembers(oldData => [...oldData, ...items]);
                    }}
                    onInputChange={value => handleSearchCollaborators(0, value)}
                    renderList={members => members.length > 0 && (
                        <div className='tr__partners d-flex flex-wrap mtx1'>
                            {members && members.length > 0 && members.map((member, memberIndex) => (
                                <ItemCard
                                    key={memberIndex}
                                    item={member}
                                    onRemove={item => {
                                        setChoseMembers(oldValue => [...oldValue.filter(val => val.id !== item.id)]);
                                    }}
                                    cardOnly={true}
                                />
                            ))}
                        </div>
                    )}
                />
            </div>
            <div className="tr__assign-modal--list">
                <AssigneeList
                    title={t("home.assign.assigned")}
                    assignees={memberSelected.map(mem => {
                        return {
                            ...mem,
                            avatar: mem.icon
                        }
                    })}
                    onRemove={handleRemovePartner}
                    minimal={!(collaborators.filter(collab => collab?.roles.includes("SHIPMENT_ADMIN")).some(each => each?.collaboratorId === userInfo?._id) ||  !(userInfo?.cognitoUserId === createdByDoc?.cognitoUserId))}
                />
            </div>
        </Modal>
    )
}
